import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carregando-indeterminado',
  templateUrl: './carregando-indeterminado.component.html',
  styleUrls: ['./carregando-indeterminado.component.css']
})
export class CarregandoIndeterminadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
